import type { AuthTokens } from "./types/auth";

const TOKEN_KEY = "auth_tokens";

export const TokenStorage = {
  getTokens: (): AuthTokens | null => {
    const tokens = localStorage.getItem(TOKEN_KEY);
    return tokens ? JSON.parse(tokens) : null;
  },

  setTokens: (tokens: AuthTokens): void => {
    localStorage.setItem(TOKEN_KEY, JSON.stringify(tokens));
  },

  removeTokens: (): void => {
    localStorage.removeItem(TOKEN_KEY);
  },

  getAccessToken: (): string | null => {
    return TokenStorage.getTokens()?.accessToken ?? null;
  },

  getRefreshToken: (): string | null => {
    return TokenStorage.getTokens()?.refreshToken ?? null;
  },

  isAuthenticated: (): boolean => {
    return !!TokenStorage.getAccessToken();
  },
};
